var filters = [];
var act_per_page = 10;
var ownFilter = false;

$.ajaxSetup({ cache: false });

$(document).ready(function() {

  if($('.post-filter select').length) {
    /*$('.post-filter select').each(function() {
      filters[$(this).data('filter')] = 'all';
      setPostFilters($(this));
    });*/
    $('.post-filter select').each(function() {
      filters[$(this).attr('data-filter')] = $(this).val();
    });

    $('.post-filter select').change(function() {
      filters[$(this).attr('data-filter')] = $(this).val();
      if($(this).attr('data-type') == 'diskussion' && $(this).attr('data-filter') == 'lang') {
        document.location.href = location.protocol + '//' + location.host + location.pathname + '?language=' + $(this).val();
      }
      else {
        setPostFilters($(this).attr('data-type'));
      }
    });
  }

  $('.platform--tab').click(function() {
    $('.platform--tab').removeClass('active');
    $(this).addClass('active');
    $('.my-content').hide();
    $('.my-content.'+$(this).attr('data-type')).show();
  });

  if($('.activity--log') && $('.activity--log').length) {
    paginate();
  }

  $('.btn--own-notifications').click(function() {
    $('.activity--log--simple:not(.own)').addClass('hidden');
    ownFilter = true;
    $('.btn--all-notifications').removeClass('active');
    $('.btn--own-notifications').addClass('active');
    paginate();
  });
  $('.btn--all-notifications').click(function() {
    $('.activity--log--simple:not(.excluded)').removeClass('hidden');
    ownFilter = false;
    $('.btn--own-notifications').removeClass('active');
    $('.btn--all-notifications').addClass('active');
    paginate();
  });

  $('.filter--check.activity-filter .filter-group input').change(function() {
    var act = $(this).val();
    if($(this).is(':checked')) {
      $('.activity--log--simple'+act).removeClass('excluded');
      if(ownFilter) {
        $('.activity--log--simple.own'+act).removeClass('hidden');
      }
      else {
        $('.activity--log--simple'+act).removeClass('hidden');
      }
    }
    else {
      $('.activity--log--simple'+act).addClass('excluded');
      $('.activity--log--simple'+act).addClass('hidden');
    }
    paginate();
  });

  $('.filter--check:not(.activity-filter) .filter-group input').change(function() {
    var act = $(this).val();
    var post_type = $(this).hasClass('themen') ? 'themen' : 'blog';
    if($(this).is(':checked')) {
      if(act == 'all') {
        //$('.filter--card').removeClass('hidden');
        $(this).attr('disabled', true);
        $('.filter-check').prop( 'checked', false );
        filters = [];
      }
      else {
        $('.filter-all').removeAttr('disabled');
        $('.filter-all').prop( 'checked', false );
        filters.push(act);
        //checkFilters();
      }
    }
    else {
      var index = filters.indexOf(act);
      if (index !== -1) {
        filters.splice(index, 1);
      }
      if(filters.length == 0) {
        //$('.filter--card').removeClass('hidden');
        $('.filter-all').attr('disabled', true);
        $('.filter-all').prop( 'checked', true );
      }
      /*else {
        checkFilters();
      }*/
    }
    //console.log(filters);
    setCheckFilters(post_type);
  });

});

function setCheckFilters(post_type) {
  var data = {
    'action': 'load_more',
    'type': post_type,
    'filter_thema': ((post_type == 'themen') ? current_thema : filters),
    'page' : 0,
    'paged': 1,
    'lang': document.documentElement.lang.substring(0,2),
    'nonce': load_more.nonce
  };
  if(post_type == 'themen') {
    data.filter_type = filters;
  }
  //console.log(data);
  load_more.current_page = 1;

  $.ajax({
    url : load_more.ajaxurl,
    data : data,
    type : 'POST',
    beforeSend : function ( xhr ) {
        $('.filter-grid').html('');
        $('.load-more').hide();
        $('.noresults').hide();
        $('.loader').show();
    },
    success : function( data ){
        if( data ) {

            //append new data
            $('.loader').hide();
            $('.filter-grid').removeClass('base-grid-blog');
            if(post_type != 'themen') $('.filter-grid').addClass('base-grid-4');
            $('.filter-grid').append(data);

            //load_more.current_page++;
            if ( load_more.current_page < max_page )
                $('.load-more').show();

        } else {
            //button.remove();
            $('.loader').hide();
            $('.noresults').show();
        }
    }
  });
}

function setPostFilters(post_type) {
  /*$('.filter').show();
  filters[sel.data('filter')] = sel.val();
  for (var filter in filters) {
    if(filters[filter] != 'all') $('.filter:not('+filters[filter]+')').hide();
  }
  if(sel.val() == 'all') {
    sel.removeClass('active');
  }
  else {
    sel.addClass('active');
  }
  if($('.filter:visible').length > 0) {
    $('.noresults').hide();
  }
  else {
    $('.noresults').show();
  }*/
  var data = {
    'action': 'load_more',
    'type': post_type,
    'filter_thema': filters['thema'],
    'filter_region': filters['region'],
    'lang': document.documentElement.lang.substring(0,2),
    'page' : 0,
    'paged': false,
    'nonce': load_more.nonce
  };
  if(post_type == 'netzwerk' || post_type == 'diskussion') {
    data.filter_lang = filters['lang'];
  }

  //console.log(data);

  load_more.current_page = 1;

  $.ajax({
    url : load_more.ajaxurl,
    data : data,
    type : 'POST',
    beforeSend : function ( xhr ) {
        //button.text('Loading...');
        $('.filter-grid').html('');
        $('.load-more').hide();
        $('.noresults').hide();
        $('.loader').show();
    },
    success : function( data ){
        if( data ) {
            //append new data
            $('.loader').hide();
            $(document).find('script.maxpage').remove();
            if($(document).find('script.post_offset')) {
              $(document).find('script.post_offset').remove();
            }
            $('.filter-grid').append(data);
            if($(document).find('script.post_offset').length && post_offset) {
              $('.load-more').attr('data-offset',post_offset);
            }
            if($(document).find('script.initial_offset').length && initial_offset) {
              $('.load-more').attr('data-initial',initial_offset);
              $('.load-more').attr('data-type','diskussion_posts');
            }
            //load_more.current_page++;
            if ( parseInt(load_more.current_page) < max_page )
                $('.load-more').show();

        } else {
            $('.loader').hide();
            $('.noresults').show();
        }
    }
  });
}

function checkFilters() {
  $('.filter--card').each(function() {
    var filtered = true;
    var card = $(this);
    filters.forEach(function (filter, index) {
      if(card.hasClass(filter)) filtered = false;
    });
    if(filtered) {
      card.addClass('hidden');
    }
    else {
      card.removeClass('hidden');
    }
  });
}

function paginate(){
  var nr = $('li.activity--log--simple:not(.hidden)').length;
  var pages = Math.ceil(nr / act_per_page);
  var paging = '';
  if(pages > 1) {
    for(var i=1;i<=pages;i++) {
      paging += '<button class="btn--paging" data-nr="'+i+'">'+i+'</button>';
    }
    setPage(1);
  }
  else {
    $('li.activity--log--simple:not(.hidden)').addClass('paged');
  }
  $('.paging').html(paging);
  if(pages > 1) {
    $('.btn--paging[data-nr="1"]').addClass('active');
    registerPaginationHandlers();
  }
}

function setPage(nr) {
  var start = (nr * act_per_page) - act_per_page;
  var end = (nr * act_per_page);
  $('li.activity--log--simple').removeClass('paged');
  $('li.activity--log--simple:not(.hidden)').slice(start,end).each(function() {
    $(this).addClass('paged');
  });
}

function registerPaginationHandlers() {
  $('.btn--paging').click(function() {
    setPage($(this).attr('data-nr'));
    $('.btn--paging').removeClass('active');
    $(this).addClass('active');
  });
}

$('#load-more').click(function(){

    var button = $(this),
        data = {
            'action': 'load_more',
            'type': $(this).attr('data-type'),
            'page' : load_more.current_page,
            'lang': document.documentElement.lang.substring(0,2),
            'nonce': load_more.nonce
        };
        if($(this).attr('data-offset')) {
          data.offset = $(this).attr('data-offset');
        }
        if($(this).attr('data-initial')) {
          data.initial = $(this).attr('data-initial');
        }
        if($(this).attr('data-type') == 'blog') {
          data.filter_thema = filters;
        }
        else if($(this).attr('data-type') == 'themen') {
          data.filter_thema = current_thema;
          data.filter_type = filters;
        }
        else {
          if(filters['thema'] && filters['thema'] != 'all') {
            data.filter_thema = filters['thema'];
          }
          if(filters['region'] && filters['region'] != 'all') {
            data.filter_region = filters['region'];
          }
          if(filters['lang'] && filters['lang'] != 'all') {
            data.filter_lang = filters['lang'];
          }
        }
        if(getUrlParameter('original_language')) {
          data.original_language = 1;
        }
        if(getUrlParameter('projekt_id')) {
          data.projekt_id = getUrlParameter('projekt_id');
        }
        var test = getUrlParameter('news');
        if(getUrlParameter('news')) {
          data.news = 1;
        }
        //console.log(data);

    $.ajax({
        url : load_more.ajaxurl,
        data : data,
        type : 'POST',
        cache: false,
        beforeSend : function ( xhr ) {
            $('.loader').show();
            $('.noresults').hide();
            button.hide();
        },
        success : function( data ){
          if( data ) {
              //reset button text
              $('.loader').hide();
              $(document).find('script.maxpage').remove();
              if($(document).find('script.post_offset')) {
                $(document).find('script.post_offset').remove();
              }
              //append new data
              $('.filter-grid').append(data);

              load_more.current_page++;

              if ( load_more.current_page < max_page ) {
                  if(button.attr('data-type') == 'diskussion_posts') {
                    if($(document).find('script.post_offset').length && post_offset) {
                      button.attr('data-offset',post_offset);
                    }
                  }
                  if($(document).find('script.initial_offset').length && initial_offset) {
                    button.attr('data-initial',initial_offset);
                    if($(document).find('script.post_offset').length && post_offset) {
                      button.attr('data-offset',post_offset);
                    }
                    button.attr('data-type','diskussion_posts');
                  }
                  button.show();
              }
          } else {
              $('.loader').hide();
              $('.noresults').show();
          }
        }
    });
});

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};
